import DatePicker from 'react-datetime-picker';
import clsx from 'clsx';
import type { DateTimePickerProps } from 'react-datetime-picker';

import IconClear from '../IconClear';
import { Calendar } from './Calendar';

export type DatepickerComponentProps = {
  value?: Date;
  format?: string;
  withIcon?: boolean;
  onChange?: (newValue: Date | null) => void;
} & Omit<
  DateTimePickerProps,
  | 'value'
  | 'format'
  | 'locale'
  | 'onChange'
  | 'clearIcon'
  | 'calendarIcon'
  | 'calendarClassName'
>;

export const DatepickerComponent: React.FC<DatepickerComponentProps> = ({
  value,
  onChange,

  disabled,
  className,
  withIcon = false,
  disableClock = true,
  format = 'y/MM/dd HH:mm',
  ...rest
}) => {
  return (
    <DatePicker
      {...rest}
      disabled={disabled}
      value={value}
      onChange={onChange!}
      clearIcon={<IconClear />}
      format={format}
      disableClock={disableClock}
      calendarIcon={withIcon && <Calendar />}
      className={clsx(
        className,
        'rounded-sm',
        'shadow-sm border border-solid border-active',
        'py-[0.35rem] px-sm bg-content outline-none w-full text-text text-medium appearance-none',
        disabled ? 'opacity-40' : ''
      )}
    />
  );
};
